import { createModel } from '@rematch/core';

import type { RootModel } from '.';
import { PaginationFactory } from '../factory';
import { PomBannerTypes } from '../types/pomBanner.types';

export interface BannersAdminStoreProps {
    pagination: PaginationFactory<PomBannerTypes.Model>;
    loading: {
        fetchMany: boolean;
        create: boolean;
        update: boolean;
        remove: boolean;
    };
}

export const bannersAdminInitialState: BannersAdminStoreProps = {
    pagination: {} as PaginationFactory<PomBannerTypes.Model>,
    loading: {
        fetchMany: false,
        create: false,
        update: false,
        remove: false,
    },
};

export const bannersAdmin = createModel<RootModel>()({
    state: bannersAdminInitialState,
    reducers: {
        toggleLoading: (
            store,
            prop: keyof BannersAdminStoreProps['loading'],
            v: boolean,
        ) => {
            store.loading[prop] = v;
        },
        setPagination: (
            store,
            pagination: PaginationFactory<PomBannerTypes.Model>,
        ) => {
            store.pagination = pagination;
        },
        removeItem: (store, id: string) => {
            store.pagination.items = (store.pagination.items || []).filter(
                (item) => item.id !== id,
            );
            store.pagination.total = Math.max(0, (store.pagination.total || 0) - 1);
        },
    },
});
